var map = {
	"./odep-icon-envelope.svg": [
		934,
		487
	],
	"./odep-icon-logo.svg": [
		92,
		784
	],
	"./odep-icon-pause.svg": [
		204,
		839
	],
	"./odep-icon-play.svg": [
		493,
		103
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = () => Object.keys(map);
webpackAsyncContext.id = 698;
module.exports = webpackAsyncContext;